export default {
    NumbersOnly(event) {
        const allowedChars = '0123456789.';
        function contains(stringValue, charValue) {
            return stringValue.indexOf(charValue) > -1;
        }
        const invalidKey = (event.key.length === 1 && !contains(allowedChars, event.key))
            || (event.key === '.' && contains(event.target.value, '.'));
        if (invalidKey) {
            event.preventDefault();
        }
    }
};
